module.exports = __webpack_public_path__ + "img/connacht-rugby-logo-icon.f48e09fc.png";